<form class="entry-page-form" [formGroup]="form" (ngSubmit)="onSubmit(form.value)" novalidate>
    <ng-container *ngIf="!isSelfEnrollment">
        <h2 class="title" *ngIf="!hideTitle && role !== 'professional'">
            Sign up as {{ role[0] === 'o' ? 'an' : 'a' }} <span class="role">{{ role }}</span>
        </h2>
    </ng-container>
    <ng-container *ngIf="isSelfEnrollment || role === 'professional'">
        <h2 class="title">Create Account on Certemy</h2>
        <div class="entry-page-form-footer">
            Already have an account?<a class="cm-link" href="javascript:void(0);" (click)="redirectToLogin()">Sign
            in</a>
        </div>
        <p class="entry-description">
            Please note that we use the Certemy platform to manage our certification and compliance programs. This is a
            separate platform that requires its own username (email) and password.
        </p>
    </ng-container>

    <cm-external-login-icons
        *ngIf="!showExternalLogin && !isOrganizationRole()"
        [signInType]="loginType"
        [settings$]="settings$"
    >
    </cm-external-login-icons>

    <ng-container *ngFor="let fieldValue of fieldValues">
        <div class="form-group" *ngIf="showField(fieldValue)">
            <label class="form-label">{{ fieldValue.label }}</label>
            <ng-container [ngSwitch]="fieldValue.type">
                <cm-select
                    *ngSwitchCase="'select'"
                    class="form-control inner-component"
                    placeholder=""
                    [options]="fieldValue.options"
                    [formControl]="fieldValue.control"
                    [ngClass]="{ 'is-invalid': fieldValue.control.errors && submitted }"
                >
                </cm-select>
                <input
                    *ngSwitchDefault
                    type="{{ fieldValue.type }}"
                    [ngClass]="{ 'is-invalid': fieldValue.control.errors && submitted }"
                    class="form-control"
                    [formControl]="fieldValue.control"
                />
            </ng-container>
        </div>
    </ng-container>

    <div class="login-buttons">
        <button class="btn ch-button full-width" type="submit">create account</button>
        <cm-iframe-external-login
            *ngIf="showExternalLogin && !isOrganizationRole()"
            [settings]="settings$ | async"
            (callback)="handleCredentialResponse($event)"
        >
        </cm-iframe-external-login>
    </div>
    <cm-inline-error *ngIf="errorMessages" [errorMessages]="errorMessages"></cm-inline-error>
</form>

<ng-template #warningTemplate>
    <div class="modal-body">
        <div class="modal-warning-wrapper">{{ warningMessage }}</div>
        <p class="modal-warning-paragraph">If you would like to create a <span class="bold-text">new</span> account,
            please select “continue” below.</p>
    </div>
</ng-template>
